export var CityImprovementTypes = /*#__PURE__*/ function(CityImprovementTypes) {
    CityImprovementTypes[CityImprovementTypes["Trade"] = 0] = "Trade";
    CityImprovementTypes[CityImprovementTypes["Politics"] = 1] = "Politics";
    CityImprovementTypes[CityImprovementTypes["Science"] = 2] = "Science";
    return CityImprovementTypes;
}({});
